/**
 * The `/categories` route (M11), in one place: `App.tsx` routes it and other
 * modules link to it (M3's "Manage categories"), so no copy can drift.
 */
export const CATEGORIES_PATH = '/categories'
